import React from 'react';
import Integrations from './components/Integrations';
import { Redirect, Route, Switch } from 'react-router-dom';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route exact path={`${match.url}`} component={Integrations} />
      <Redirect to="/error" />
    </Switch>
  </div>
);

export default UI;
